import React, { useImperativeHandle, useState, forwardRef } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const ErrorModal = forwardRef(({ errorListRef }, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
    close: () => setOpen(false),
  }));

  // errorListRef varsa current'ini, yoksa boş dizi kullanıyoruz.
  const errors = errorListRef?.current || [];

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        sx={{
          position: 'absolute',
          width: 400,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}
      >
        <Typography variant="h6">Hatalı Satır ve Sütunlar</Typography>
        {errors.map((error, index) => (
          <Typography key={index}>
            Satır {error.row}, Sütun {error.column} hatalı.
          </Typography>
        ))}
        <Button onClick={() => setOpen(false)} sx={{ mt: 2 }}>
          Tamam
        </Button>
      </Box>
    </Modal>
  );
});

export default ErrorModal;
